// any intended
export const getDirtyValues = (values: any, initialValues: any) => {
  const dirtyValues: any = {};
  Object.keys(values).forEach((key) => {
    if (values[key] !== initialValues[key]) {
      dirtyValues[key] = values[key];
    }
  });
  return dirtyValues;
};
